import styles from "./styles.module.scss";
import finger from "@assets/img/emoji/fingerup.png";
import { Button } from "../../../../../../common";
import { closeModal } from "../../../../../../utils/modal";

export const Modal = ({ onContinue }) => {
  const handleContinue = () => {
    closeModal();
    onContinue();
  };

  return (
    <div className={styles.modal}>
      <div className={styles.icon}>
        <img src={finger} alt="icon" />
      </div>
      <h4>Thanks for sharing!</h4>
      <p>
        We've found that many people face the same issues. Walky offers all the
        tools you need to maintain a consistent walking routine and make
        progress toward your goals.
      </p>
      <Button variant="walky" onClick={handleContinue}>
        Continue
      </Button>
    </div>
  );
};

